import React, { useEffect } from "react";
import { useRoutes, useLocation } from "react-router-dom";
import { ROUTES } from "./routes";
import Layout from "../components/Layout/PageLayout";
import { captureAttribution } from "../utils/marketingAttribution";

const RouteWrapper = () => {
  const routes = useRoutes(ROUTES);
  return routes;
};

const Pages = () => {
  const location = useLocation();

  useEffect(() => {
    captureAttribution(true);
  }, [location.pathname, location.search]);

  return (
    <Layout>
      <RouteWrapper key={location.pathname} />
    </Layout>
  );
};

export default Pages;
